import { render, staticRenderFns } from "./AlipayTransfer.vue?vue&type=template&id=52c303f6&scoped=true"
import script from "./AlipayTransfer.vue?vue&type=script&lang=js"
export * from "./AlipayTransfer.vue?vue&type=script&lang=js"
import style0 from "./AlipayTransfer.vue?vue&type=style&index=0&id=52c303f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c303f6",
  null
  
)

export default component.exports